<template>
<main-content>
    <request-filter :action="filterAction" ></request-filter>
    <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { requestFilter, actionsColumn } from './components'
import columns from "./datatable/columns";
import { AuthorizationHeader } from '@/common/jwt.service'
import { ApiUrl } from '@/common/api.service'

export default {
    name: "Get",

    components: {
        'main-content': mainContent,
        'request-filter': requestFilter,
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "psp_request_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('psp-request/admin'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style scoped>

</style>